// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const leaderProfileBusinessApproachAPI = createApi({
  reducerPath: 'leaderProfileBusinessApproachAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['BusinessApproach'],
  endpoints: (builder) => ({
    getBusinessApproachData: builder.query<any, leaderProfileBusinessApproachArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/business/approach`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'BusinessApproach', id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
    createBusinessApproach: builder.mutation<any, leaderProfileBusinessApproachArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/business/approach`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'BusinessApproach', id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBusinessApproachDataQuery, useCreateBusinessApproachMutation } =
  leaderProfileBusinessApproachAPI;
